<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("stockRoadway.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("stockRoadway.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <!-- 巷道编码 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("stockRoadway.Fields.code") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('stockRoadway.Fields.code')"
                    rules="required"
                  >
                    <!-- 编辑信息 -->
                    <v-text-field
                      single-line
                      v-model="stock_roadway.code"
                      :hint="isNew ? '' : $t('stockRoadway.codeHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'code')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <!-- 查看信息 -->
                  {{ stock_roadway.code }}
                </v-col>
              </v-row>
              <!-- 所属仓库 -->
              <v-row align="center" v-if="!isNew">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("stockRoadway.Fields.stock_name") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  {{
                    stock_roadway && stock_roadway.stock
                      ? stock_roadway.stock.name
                      : ""
                  }}
                </v-col>
              </v-row>
              <!-- 所属库区 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("stockRoadway.Fields.area_name") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('stockRoadway.Fields.area_name')"
                    rules="required"
                  >
                    <SearcherStockArea
                      v-model="stockAreasSelected"
                      :stock-id="stock_id"
                      no-label
                      unclearable
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'stock_container_code')
                          .concat(errors)
                      "
                    />
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    stock_roadway && stock_roadway.stock_area
                      ? stock_roadway.stock_area.area_name
                      : ""
                  }}
                </v-col>
              </v-row>
              <!-- 排序规则 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("stockRoadway.Fields.sort_type") + $t("Global.colon") }}
                  <Required :show="savable" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="stock_roadway.sort_type">
                    <v-radio
                      :label="$t('stockRoadway.Fields.on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('stockRoadway.Fields.off')"
                      :key="2"
                      :value="2"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- 商品分类 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("stockRoadway.Fields.material_category") + $t("Global.colon") }}
                  <Required :show="savable" />
                </v-col>
                <v-col cols="9" md="7">
                  <SearcherMaterialCategoriesWithDescendants
                    v-model="materialCategoriesSelected"
                    noLabel
                  />
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                outlined
                color="secondary"
                class="elevation-1"
                block
                @click="
                  $emit('input', null);
                  $emit('mode', null);
                "
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.backToList", [$t("stockRoadway.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="isView">
              <v-btn
                color="accent"
                block
                :disabled="loading && !stock_roadway.id"
                @click="$emit('mode', 'edit')"
              >
                <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                {{ $t("CRUD.editInfo", [$t("stockRoadway.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="savable">
              <!-- 保存 -->
              <v-btn
                color="success"
                block
                :disabled="loading && !stock_roadway.id"
                @click="save()"
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.saveInfo", [$t("stockRoadway.ObjectName")]) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Consts from "@/consts.js";
import Required from "@/components/plugins/Required";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import StockRoadways from "@/api/stock_roadways";
import SearcherStockArea from "@/components/plugins/SearcherStockArea";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";

export default {
  props: ["value", "mode"],
  components: {
    Required,
    ValidationObserver,
    ValidationProvider,
    SearcherStockArea,
    SearcherMaterialCategoriesWithDescendants,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    status() {
      return Consts.stock.status;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    serverErrors: [],
    stock_roadway: {},
    stockAreasSelected: null,
    materialCategoriesSelected: [],
  }),

  mounted() {
    if (this.$route.query.stock_id) {
      this.stock_id = Number(this.$route.query.stock_id);
    }
  },

  methods: {
    save() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            var stock_roadway = JSON.parse(JSON.stringify(this.stock_roadway));
            delete stock_roadway.stock;
            delete stock_roadway.stock_area;
            //校验成功再提交
            StockRoadways.save(stock_roadway.id, stock_roadway)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", this.stock_roadway);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          StockRoadways.fetchOne({ id: this.value.id }).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stock_roadway = response.data.stock_roadway;
                this.stockAreasSelected = this.stock_roadway.stock_area;
              }
            }.bind(this)
          );
        } else {
          // 新建仓库，初始化默认值
          this.stock_roadway = {
            stock_id: this.$route.query.stock_id,
            sort_type: 1,
          };
          this.stockAreasSelected = null;
          this.materialCategoriesSelected = [];
        }
        this.$scrollTop(); //返回顶部
      },
    },
    stockAreasSelected: {
      handler() {
        this.stock_roadway.stock_area_id = this.stockAreasSelected
          ? this.stockAreasSelected.id
          : "";
      },
    },
    materialCategoriesSelected: {
      handler() {
        this.stock_roadway.stock_roadway_categories = this.materialCategoriesSelected
          ? this.materialCategoriesSelected.map((category) => {
              return category.code;
            })
          : [];
      }
    },
  },
};
</script>